import { styled } from "@mui/system";
import React from "react";
import { getLabelStyles } from "./Styles";
import useGetThemePath from "../../hooks/useGetThemePath";
import { ThemePaths } from "../../theme";

const Label = ({
  children,
  ...props
}: React.LabelHTMLAttributes<HTMLLabelElement>) => {
  const themePath = useGetThemePath();

  // Use the theme-aware styles
  const ThemedLabel = styled("label")`
    ${getLabelStyles(themePath as ThemePaths)}
  `;

  return <ThemedLabel {...props}>{children}</ThemedLabel>;
};

export default Label;
